import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "my-section" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "my-title uppercase" }, "Lista delle macchine", -1)
const _hoisted_4 = { class: "my-buttons my-card--body" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Aggiorna Dati ")
const _hoisted_6 = {
  id: "lista-tabella",
  class: "justify-center container my-10 w-full"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"row flex md:grid grid-cols-1 gap-1 md:grid-cols-12\" style=\"background-color:#aca9a4;border-radius:10px;\"><div class=\"riga13 col-span-1 text-center font-bold\">SERIALE</div><div class=\"col-span-2 text-center d-lg-block d-none font-bold\"> TIPO </div><div class=\"col-span-4 text-center d-md-block d-none font-bold\"> DESCRIZIONE </div><div class=\"col-span-1 text-center d-md-block d-none font-bold\"></div><div class=\"riga13 col-span-2 text-center font-bold\">AZIONI</div><div class=\"riga13 col-span-2 text-center font-bold\">AZIONI</div></div>", 1)
const _hoisted_8 = {
  key: 0,
  class: "mySpinner"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border mb-3",
  role: "status"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, " Caricamento in corso... ", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "riga13 col-span-1 text-center d-flex align-items-center justify-content-center" }
const _hoisted_13 = { class: "font-bold capitalize" }
const _hoisted_14 = { class: "riga13 col-span-4 text-center d-md-block d-none d-lg-flex align-items-center justify-content-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 d-md-block d-none text-center" }, null, -1)
const _hoisted_16 = { class: "riga13 col-span-2 text-center d-flex align-items-center justify-content-center font-bold lead" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Dati ")
const _hoisted_18 = { class: "riga13 col-span-2 text-center d-flex align-items-center justify-content-center font-bold lead" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Clienti ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Image = _resolveComponent("Image")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Button, {
          class: "is-secondary",
          icon: "fas fa-sync",
          onClick: _ctx.refreshListMachines
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        (_ctx.dbData.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbData, (dbDataRow, cRow) => {
          return (_openBlock(), _createElementBlock("div", {
            key: cRow,
            class: "row flex md:grid grid-cols-1 gap-1 md:grid-cols-12"
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.get(dbDataRow, 'codice', '')), 1)
            ]),
            _createVNode(_component_Image, {
              seriale: dbDataRow.codice.toString(),
              config: _ctx.tipoTagConfig,
              dbData: dbDataRow
            }, null, 8, ["seriale", "config", "dbData"]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", null, _toDisplayString(_ctx.get(dbDataRow, 'description', '')), 1)
            ]),
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_RouterLink, {
                to: {
                  name: 'Machine',
                  params: {
                    machineId: _ctx.get(dbDataRow, 'codice', 'err'),
                  },
                }
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_RouterLink, {
                to: {
                  name: 'CustomerList',
                  params: {
                    machineId: _ctx.get(dbDataRow, 'codice', 'err'),
                  },
                }
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}